import axios from 'axios';

import { FEES_API_URL } from 'constants/api';

const feesAPI = axios.create({
  baseURL: FEES_API_URL,
});

export default feesAPI;
